module.exports = __webpack_public_path__ + "static/img/线上续方@3x.fw.9bb1863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/nav/线上续方@3x.fw.png
// module id = 781
// module chunks = 358